import { AxiosRequestConfig } from 'axios';
import { toLower } from 'lodash';
import { Required } from 'utility-types';

import { axios } from './axios';

export const makeRequest = <Dto>({
  url,
  method = 'get',
  ...rest
}: Required<AxiosRequestConfig, 'url'>): Promise<Dto> => {
  const lowerCasedMethod = toLower(method);
  const { data, ...otherOptions } = rest;

  return (
    lowerCasedMethod === 'get'
      ? axios.get<Dto>(url, rest)
      : axios[lowerCasedMethod]<Dto>(url, data, otherOptions)
  ).then(({ data }) => data);
};
